import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
let store = new Vuex.Store({
  // 1. state
  state: {
    isAcitve: 0,
    roleid: ''
  },
  // // 2. getters
  getters: {
    // 参数列表state指的是state数据
    getIsActivity(state) {
      return state.isAcitve;
    },
    getRoleId(state){
      return state.roleid; 
    },
  },
  // 3. actions
  // 通常跟api接口打交道
  actions: {
    setIsActivityName({
      commit,
      state
    }, name) {
      // 跟后台打交道
      // 调用mutaions里面的方法
      commit("setIsActive", name);
    },
    setRoleIdNae({
      commit,
      state
    }, name) {
      // 跟后台打交道
      // 调用mutaions里面的方法
      commit("setRoleId", name);
    },
  },
  // 4. mutations
  mutations: {
    setIsActive(state, name) {
      state.isAcitve = name; //将传参设置给state的city
    },
    setRoleId(state, name) {
      state.roleid = name; //将传参设置给state的city
    },
  }
});

export default store;